import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuccessGuardService } from '../../shared/services/guard-services/success-guard.service';
import { PersmissionGuardService } from '../../shared/services/guard-services/persmission-guard.service';
import { ExplorePageComponent } from "./components/explore-page/explore-page.component";

const routes: Routes = [
    {
        path: '',
        component: ExplorePageComponent,
        // canActivate: [PersmissionGuardService]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [SuccessGuardService, PersmissionGuardService]
})
export class ExploreRoutingModule {
}

